var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_7042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.642 0H264V62.3584H201.642V0Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0825195 178.433H184.912V264.786H0.0825195V178.433Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.405 25.4414H167.952C176.054 25.4414 183.311 29.0631 188.187 34.7776C186.93 36.2535 185.828 37.862 184.913 39.5866C180.446 31.1725 171.594 25.4414 161.405 25.4414Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.023 53.8177C235.023 39.1551 223.16 25.4974 208.511 25.4443H214.968C229.66 25.4443 241.57 39.1286 241.57 53.821C241.57 93.9683 191.46 118.047 191.46 118.047H184.913C184.913 118.047 235.023 93.9716 235.023 53.821V53.8177Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.803 53.8181C134.803 39.1256 146.713 25.4414 161.405 25.4414C171.597 25.4414 180.446 31.1725 184.913 39.5866C189.381 31.1725 198.233 25.4414 208.421 25.4414C223.114 25.4414 235.023 39.1256 235.023 53.8181C235.023 93.9653 184.913 118.044 184.913 118.044C184.913 118.044 134.803 90.8046 134.803 53.8181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1469_7042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.789 108.227C66.4664 105.878 60.2066 101.429 66.1891 96.641C73.9374 90.4435 108.298 82.5537 100.771 100.767L100.324 100.835C100.278 100.841 100.227 100.852 100.176 100.858C105.825 100.003 110.047 99.7992 110.534 100.988C111.841 104.186 98.054 107.406 98.054 107.406C98.4332 104.457 97.4993 101.305 97.4936 101.293C85.308 103.393 68.7417 107.712 66.789 108.227Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3094 258.988V158.282H43.8951H56.092V254.55L32.3094 258.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.267 386.136L239.114 380.731C239.114 380.731 235.373 374.749 235.373 360.543V281.899C235.373 272.742 229.543 264.597 220.867 261.648L133.887 232.07L129.642 230.536H50.9586V254.019C50.9586 254.019 76.7901 248.84 104.195 262.593C124.559 272.815 136.207 290.74 136.207 290.74L169.787 295.868V386.38L200.124 382.044C200.124 383.601 200.542 384.942 201.256 386.142L201.267 386.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.738 250.034V238.137C186.738 232.29 181.984 227.536 176.137 227.536H151.777L149.202 232.064H176.137C179.488 232.064 182.21 234.786 182.21 238.137V248.495L186.738 250.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.301 152.562L127.027 178.258L119.137 184.642L118.939 184.744C114.326 177.104 113.019 175.094 112.43 173.855C111.734 172.378 110.144 170.827 110.444 166.718C110.444 164.668 109.272 153.983 108.301 152.562Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3908 122.625C71.7075 121.969 74.0903 119.444 74.0903 119.444C67.2192 113.932 75.4939 104.916 80.6783 112.205C83.0611 108.464 83.1913 104.219 83.1913 104.219C83.5875 104.123 83.961 104.044 84.3176 103.965C90.051 102.725 97.6522 101.469 97.6522 101.469C98.1616 103.342 98.32 105.351 98.054 107.412L95.4335 127.827C94.76 133.09 90.3906 137.063 85.1383 137.307V146.357L67.8757 146.442L68.7417 129.123C68.7926 127.425 68.7247 125.721 68.5436 124.029L68.3908 122.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6784 112.206C75.4884 104.916 67.2194 113.937 74.0904 119.444C74.0904 119.444 71.7076 121.969 68.3909 122.625L66.8005 108.278C66.8005 108.278 77.1807 105.572 83.1914 104.214C83.1914 104.214 83.0612 108.464 80.6784 112.206Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2818 427.651C16.0407 427.651 -23.0664 388.544 -23.0664 340.302C-23.0664 292.061 16.0407 252.954 64.2818 252.954C112.523 252.954 151.63 292.061 151.63 340.302C151.63 388.544 112.523 427.651 64.2818 427.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2818 419.257C20.6763 419.257 -14.6729 383.908 -14.6729 340.302C-14.6729 296.697 20.6763 261.348 64.2818 261.348C107.887 261.348 143.237 296.697 143.237 340.302C143.237 383.908 107.887 419.257 64.2818 419.257Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3071 158.283V153.778C37.3071 151.881 36.5261 150.065 35.1451 148.763L22.4444 136.787C21.5218 135.943 20.0899 136 19.2466 136.923C18.4033 137.845 18.4599 139.277 19.3824 140.12L32.3095 152.023V158.283H37.3071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.157 227.418C129.161 187.221 110.625 178.568 110.625 168.493V160.196C110.625 152.555 104.427 146.357 96.7863 146.357H57.2297L47.1779 227.418H130.151H130.157Z",
    fill: "#E3E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3071 184.137L44.6365 155.362C46.1647 149.397 51.949 145.548 58.039 146.442C65.0572 147.472 69.67 154.315 67.9834 161.209L60.9199 190.278L37.3014 184.137H37.3071Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1641 146.436L87.8265 155.288L72.4997 146.312L90.1641 146.436Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.774 232.064C153.124 232.064 155.847 234.786 155.847 238.137V401.095C155.847 407.049 160.691 411.894 166.646 411.894H256.812C258.063 411.894 259.076 410.881 259.076 409.63C259.076 408.379 258.063 407.366 256.812 407.366H166.651C163.193 407.366 160.38 404.553 160.38 401.095V238.137C160.38 232.29 155.626 227.536 149.779 227.536H19.9143C18.6635 227.536 17.6504 228.549 17.6504 229.8C17.6504 231.051 18.6635 232.064 19.9143 232.064H149.779H149.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5665 222.211C27.674 221.724 27.8098 221.254 27.9683 220.796L37.3071 184.143L60.9255 190.284L54.8752 215.187L102.888 226.308C106.448 227.135 109.628 229.138 111.904 232.002L121.265 244.675C123.184 247.086 122.867 250.578 120.546 252.604C118.413 254.466 115.243 254.506 113.064 252.695L101.037 243.288L39.022 237.843C31.2737 237.164 25.8855 229.823 27.5665 222.222V222.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8073 127.674C74.4355 133.175 79.0936 137.324 84.6289 137.324C90.1076 137.324 94.7373 133.254 95.4335 127.821L98.054 107.406C98.32 105.346 98.1616 103.336 97.6522 101.463",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.965 184.952L119.124 184.802L127.004 178.428L130.553 183.386L130.785 183.698L142.032 142.499C142.99 138.99 145.945 136.387 149.547 135.883L166.19 133.545C168.956 133.157 171.489 135.143 171.771 137.919C171.967 139.829 171.035 141.677 169.383 142.655L156.943 150.031L150.718 208.231C149.892 215.958 142.456 221.199 134.901 219.374C132.984 218.913 131.103 218.054 129.535 216.734C129.535 216.734 128.026 206.314 126.079 200.938L126.092 200.891C125.266 198.321 122.809 191.233 119.124 185.214C119.071 185.124 119.018 185.041 118.965 184.955V184.952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.144 137.471V146.351",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5909 108.278C66.5909 108.278 108.932 97.0654 110.54 100.988C111.847 104.185 98.0596 107.406 98.0596 107.406",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8758 146.436L68.7418 129.117C68.7927 127.419 68.7248 125.716 68.5437 124.023L66.8005 108.278C66.5627 105.94 60.1615 101.463 66.1948 96.641C73.9432 90.4435 108.304 82.5537 100.776 100.767",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1914 104.214C83.1914 104.214 83.0612 108.464 80.6784 112.2C75.4884 104.91 67.2193 113.932 74.0904 119.439C74.0904 119.439 71.7076 121.963 68.3909 122.62",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2353 146.352H96.7919C104.433 146.352 110.63 152.549 110.63 160.19V168.487C110.63 178.562 129.166 187.216 130.162 227.412",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.546 252.592C122.867 250.566 123.184 247.074 121.265 244.663L111.904 231.99C109.628 229.126 106.448 227.123 102.888 226.296L43.0574 212.435C36.0732 210.817 29.1172 215.209 27.5664 222.204C25.8855 229.8 31.268 237.141 39.022 237.825L101.037 243.27L113.064 252.677C115.243 254.488 118.413 254.448 120.546 252.586V252.592Z",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9683 220.79L44.6365 155.356C46.1647 149.391 51.949 145.542 58.039 146.436C65.0572 147.466 69.67 154.309 67.9834 161.203L54.8752 215.175",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9255 190.272L37.3071 184.137",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.027 178.266L118.945 184.799",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1641 146.436L87.8265 155.288L72.4997 146.312",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38 241.074L220.878 261.648C229.549 264.597 235.384 272.741 235.384 281.899V360.542C235.384 374.748 239.125 380.731 239.125 380.731L201.278 386.136",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.892 232.064L155.666 239.468",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38 251.211L191.062 261.642C199.733 264.591 205.568 272.735 205.568 281.893V360.536C205.568 374.743 209.31 380.725 209.31 380.725L169.804 386.368",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.603 235.646L155.852 249.672",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2818 427.651C16.0407 427.651 -23.0664 388.544 -23.0664 340.302C-23.0664 292.061 16.0407 252.954 64.2818 252.954C112.523 252.954 151.63 292.061 151.63 340.302C151.63 388.544 112.523 427.651 64.2818 427.651Z",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2818 419.257C20.6763 419.257 -14.6729 383.908 -14.6729 340.302C-14.6729 296.697 20.6763 261.348 64.2818 261.348C107.887 261.348 143.237 296.697 143.237 340.302C143.237 383.908 107.887 419.257 64.2818 419.257Z",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9641 254.013V238.879",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.102 232.064H149.779C153.13 232.064 155.852 234.786 155.852 238.137V401.095C155.852 407.049 160.697 411.894 166.651 411.894H256.812C258.063 411.894 259.076 410.881 259.076 409.63C259.076 408.379 258.063 407.366 256.812 407.366H166.651C163.193 407.366 160.38 404.553 160.38 401.095V238.137C160.38 232.29 155.626 227.536 149.779 227.536H106.374",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.408 227.536H19.9087C18.6579 227.536 17.6448 228.549 17.6448 229.8C17.6448 231.051 18.6579 232.064 19.9087 232.064H29.2588",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.738 250.034V238.137C186.738 232.29 181.984 227.536 176.137 227.536H151.777",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.461 232.064H176.143C179.493 232.064 182.216 234.787 182.216 238.137V248.495",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3093 203.753V196.673M43.895 158.282H32.3093V163.798C32.3093 168.216 28.7276 171.798 24.3093 171.798H-29.5155",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3093 258.988V235.223",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3095 158.282V152.022L19.3824 140.12C18.4599 139.276 18.3976 137.844 19.2466 136.922C20.0899 135.999 21.5218 135.937 22.4444 136.786L35.1451 148.762C36.5261 150.064 37.3071 151.881 37.3071 153.777V158.282",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.349 216.407C130.918 217.723 133.113 219.01 135.03 219.475C142.585 221.295 150.021 216.058 150.847 208.331L157.072 150.131L169.513 142.755C171.164 141.777 172.093 139.93 171.901 138.019C171.451 133.553 167.752 133.375 161.908 134.062",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.186 34.7776C183.308 29.0631 176.051 25.4414 167.952 25.4414H161.405",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.452 64.1357C233.059 98.0544 191.46 118.043 191.46 118.043H184.913",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51 25.4414H214.968C223.438 25.4414 230.98 29.9884 235.852 36.6548C236.821 37.9814 238.373 38.7608 240.014 38.7608H264",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.346 77.2396C137.37 70.0658 134.8 62.1889 134.8 53.8113C134.8 39.1188 146.709 25.4346 161.402 25.4346C171.59 25.4346 180.442 31.1656 184.91 39.5798C189.377 31.1656 198.226 25.4346 208.418 25.4346C223.11 25.4346 235.02 39.1188 235.02 53.8113C235.02 93.9618 184.91 118.037 184.91 118.037C184.91 118.037 175.026 112.664 164.039 103.451C163.11 102.671 161.932 102.24 160.715 102.24H150.222C147.366 102.24 145.048 104.555 145.048 107.414V135.336C145.048 136.593 144.61 137.824 143.761 138.749C142.806 139.797 142.086 141.071 141.698 142.497L130.673 183.241L107.789 151.899",
    stroke: "#7F9398",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_7042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "white",
    transform: "matrix(-1 0 0 1 264 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1469_7042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282.709,
    height: 338.719,
    fill: "white",
    transform: "matrix(-1 0 0 1 259.359 89.2158)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.d83f10a3.svg";
export { ForwardRef as ReactComponent };